import axios from 'axios';

import { cacheAudio, getAudio } from '../../utils/audioCache/audioCache';
import { getDecoded, getVoiceToken } from '../../utils/voiceToken/voiceToken';
import { getServiceURI } from '../../globals/serviceURI/serviceURI';
import { SYNTHESIZE_PATH } from '../../constants';

/**
 * @param voice
 * @param text
 * @returns {Promise<T|*>}
 */
export default async (voice, text) => {
  if (!voice) {
    throw Error('Voice param required');
  }

  if (!text || !text.trim()) {
    throw Error('Text param required');
  }

  const audio = getAudio(voice.id, text.trim());
  if (audio) {
    return {
      error: null,
      data: audio,
    };
  }

  const token = getDecoded();

  if (!token) {
    throw Error('Must call authenticate first to get voice token');
  }

  if (Math.floor(Date.now() / 1000) >= token.exp) {
    throw Error('Voice token expired');
  }

  const res = await axios.request({
    method: 'post',
    url: `${getServiceURI()}${SYNTHESIZE_PATH}`,
    headers: {
      Authorization: `Bearer ${getVoiceToken()}`,
    },
    data: {
      voice,
      text: text.trim(),
    },
    validateStatus: (status) => status < 501,
  });

  if (res.status === 400) {
    return {
      errorMessage: res.data.message || res.statusText,
      line: res.data.line,
      col: res.data.col,
      data: null,
    };
  }

  if (res.status === 500) {
    return {
      errorMessage: res.statusText,
      line: 0,
      col: 0,
      data: null,
    };
  }

  cacheAudio(voice.id, text.trim(), res.data);

  return {
    error: null,
    data: res.data,
  };
};
